"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault"),
    _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react")),
    _Uploader = require("../../Uploader"),
    _UploadFilesModal = _interopRequireDefault(require("../../UploadFilesModal"));

function UploadFiles(a) {
  var b = a.onVideoAdd,
      c = a.modalVisible,
      d = a.toggleModal,
      e = a.postOrganisationId,
      f = a.selectedOrganisationId;
  return _react["default"].createElement(_Uploader.UploaderConsumer, null, function (a) {
    var g = a.addFileToQueue;
    return _react["default"].createElement(_UploadFilesModal["default"], {
      visible: c,
      organisationId: e || f,
      onSave: b,
      onClose: d,
      addFileToQueue: g,
      maxFiles: 1,
      allowedExtensions: ["video/*"],
      allowEmbed: !0
    });
  });
}

var _default = (0, _react.memo)(UploadFiles);

exports["default"] = _default;